<template>
  <div
    class="hc-carousel"
    data-testid="hc-carousel-root"
    @mouseenter="stopAutoplay"
    @mouseleave="startAutoplay"
  >
    <div
      class="hc-carousel__viewport"
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
    >
      <div
        class="hc-carousel__track"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <component
          :is="slide.link ? 'a' : 'div'"
          v-for="(slide, index) in slides"
          :key="index"
          class="hc-carousel__slide"
          :href="slide.link || null"
          :target="slide.link ? '_blank' : null"
          :rel="slide.link ? 'noopener noreferrer' : null"
        >
          <img
            v-if="slide.image"
            class="hc-carousel__image"
            :src="slide.image"
            :alt="slide.title"
            loading="lazy"
          />
          <div
            v-if="slide.title || slide.description"
            class="hc-carousel__caption"
          >
            <h4 v-if="slide.title" class="hc-carousel__title">
              {{ slide.title }}
            </h4>
            <p v-if="slide.description" class="hc-carousel__description">
              {{ slide.description }}
            </p>
          </div>
        </component>
      </div>

      <button
        v-if="showNavigation"
        type="button"
        class="hc-carousel__nav hc-carousel__nav--prev"
        aria-label="Previous"
        data-testid="hc-carousel-prev"
        @click="prev"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <button
        v-if="showNavigation"
        type="button"
        class="hc-carousel__nav hc-carousel__nav--next"
        aria-label="Next"
        data-testid="hc-carousel-next"
        @click="next"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>

    <div v-if="showIndicators" class="hc-carousel__indicators">
      <button
        v-for="(slide, index) in slides"
        :key="index"
        type="button"
        class="hc-carousel__dot"
        :class="{ 'is-active': index === currentIndex }"
        :aria-label="`Go to slide ${index + 1}`"
        :data-testid="`hc-carousel-dot-${index}`"
        @click="goTo(index)"
      />
    </div>
  </div>
</template>

<script>
import carouselMixin from './mixins/carouselMixin';

export default {
  name: 'CarouselBlock',
  mixins: [carouselMixin],
};
</script>

<style src="./styles/CarouselBlock.scss" lang="scss" scoped></style>
